import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
/**
 * GameConfigData.ts
 */
export class GameConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.numberOfSpins = this.data.getNumber(SlingoConstants.PROPERTY_NUMBER_OF_SPINS);
            this.numberOfPurchaseSpins = this.data.getNumber(SlingoConstants.PROPERTY_NUMBER_OF_PURCHASE_SPINS);
            this.minimumSpinDuration = this.data.getNumber(SlingoConstants.PROPERTY_MINIMUM_SPIN_DURATION);
            this.celebrateWinThreshold = this.data.getNumber(SlingoConstants.PROPERTY_CELEBRATE_WIN_THRESHOLD);
            this.maximumStakeToSpinAttempts = this.data.getNumber(SlingoConstants.PROPERTY_MAXIMUM_STAKE_TO_SPIN_ATTEMPTS);
            this.minimumStakeToSpinChance = this.data.getNumber(SlingoConstants.PROPERTY_MINIMUM_STAKE_TO_SPIN_CHANCE);
            this.stakeToSpinEnabled = this.data.getBool(SlingoConstants.PROPERTY_STAKE_TO_SPIN_ENABLED);
        }
    }
    getNumberOfSpins() {
        return this.numberOfSpins;
    }
    getNumberOfPurchaseSpins() {
        return this.numberOfPurchaseSpins;
    }
    getMinimumSpinDuration() {
        return this.minimumSpinDuration;
    }
    getCelebrateWinThreshold() {
        return this.celebrateWinThreshold / 100; //convert percentage to ratio
    }
    getMaximumStakeToSpinAttempts() {
        return this.maximumStakeToSpinAttempts;
    }
    getMinimumStakeToSpinChance() {
        return this.minimumStakeToSpinChance;
    }
    getStakeToSpinEnabled() {
        return this.stakeToSpinEnabled;
    }
}
//# sourceMappingURL=GameConfigData.js.map